/**
 * Helper module to format block lifecycle
 * Topic "herdKeeper"
 */

export default { 
    
    getList(dirty) {
        // this will hold final event list
        let list = {};
        
        // parse list
        for(let k in window.przWlblk){
			const data = window.przWlblk[k];
			if(data.d === dirty){
				// collection data to send
				list[k] = {
					s: data.s,
					p: data.p,
					o: data.o,
					g: data.g
				}
				window.przWlblk[k].d = false;
			}
		}
        
        //console.log('weblog_blocks: list', JSON.stringify(list));
        return list;
    },
    
    add(s, b, p, o, g) {
        // event queue
        window.przWlblk = window.przWlblk || {}; 
        if(window.przWlblk.hasOwnProperty(b)){
			if(window.przWlblk[b].s != s){
				window.przWlblk[b].s = s;
				// new process state, mark item as dirty
				window.przWlblk[b].d = true;
				//console.log('weblog_blocks: updated '+b, window.przWlblk[b]);
			}
		}
		else if(s != 'WLBLK_VIEW'){
			// event "view" is discarded if there is no load/render  
			window.przWlblk[b] = {
				s: s,			// state
				p: p ? p : '',  // WS context = event process
				o: o ? o : 0,	// order
				g: g ? g : '',	// grid	
				d: true,		// dirty
			}
			//console.log('weblog_blocks: added '+b, window.przWlblk[b]);
		}
    },
    
    flush(){
        if(window.mub){
			//console.log('weblog_blocks flush data');
            window.mub.flushData('herdkeeper_flush');
        }
		
	}
};
